import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import MailCheckInput from '../MailCheckInput'
import { cpfMask, cnpjMask } from '../../../util/document'

const MAX_CPF_DIGITS = 11

const applyMask = value => {
  if (!value) return value
  if (value.includes('@')) return value

  const digits = value.replace(/\D/g, '')
  if (digits.length > 0 && /^[\d./-]+$/.test(value)) {
    return digits.length > MAX_CPF_DIGITS ? cnpjMask(value) : cpfMask(value)
  }
  return value
}

const IdentifierInput = ({
  value,
  error,
  hasError,
  inputRef,
  disabled,
  onBlur,
  onChange,
  onSuggestionClick,
  onFocus,
}) => {
  const [showError, setShowError] = useState(false)

  const handleChange = useCallback(
    event => {
      setShowError(false)

      if (event?.target) {
        const rawValue = event.target.value
        const masked = applyMask(rawValue)

        if (masked !== rawValue) {
          const syntheticEvent = {
            ...event,
            target: { ...event.target, value: masked },
          }
          if (onChange) onChange(syntheticEvent)
          return
        }
      }

      if (onChange) onChange(event)
    },
    [onChange]
  )

  const handleBlur = useCallback(
    event => {
      setShowError(true)
      if (onBlur) onBlur(event)
    },
    [onBlur]
  )

  const handleFocus = useCallback(
    event => {
      setShowError(false)
      if (onFocus) onFocus(event)
    },
    [onFocus]
  )

  const shouldDisplayError = hasError && showError

  return (
    <MailCheckInput
      label="E-mail, CPF ou CNPJ"
      value={value}
      error={shouldDisplayError ? error : undefined}
      hasError={shouldDisplayError}
      inputRef={inputRef}
      disabled={disabled}
      onBlur={handleBlur}
      onChange={handleChange}
      onSuggestionClick={onSuggestionClick}
      onFocus={handleFocus}
    />
  )
}

IdentifierInput.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  hasError: PropTypes.bool,
  inputRef: PropTypes.func,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onSuggestionClick: PropTypes.func,
  onFocus: PropTypes.func,
}

export default IdentifierInput
